import React from 'react';

export default function SpinnerPadrao({ ...props }) {
    return <div style={{ textAlign: 'center', userSelect: "none", pointerEvents: "none" }} >
        <svg style={{ width: 90, height: 90, ...props.style }} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <path d="M10 50A40 40 0 0 0 91 50A40 43 1 0 1 10 50" stroke="none" className='spinner-fill'>
                <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 50 51;360 50 51" />
            </path>
        </svg>
    </div>;
}